<template>
  <div class="content">
    <div class="page-inner">
      <div class="mb-4">
        <h1>
          AI <span class="text-primary fw-bold">Beat</span> Generator
        </h1>
        <div class="text-right">
          <span class="badge badge-warning">
            {{ available }} {{ $t('available_this_month') }}
          </span>
        </div>
      </div>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tab === 'generator' }" aria-current="page" href="javascript:void(0)" @click="tab = 'generator'">
            {{ $t('generator') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tab === 'beats' }" href="javascript:void(0)" @click="tab = 'beats'">
            {{ $t('my_beats') }}
          </a>
        </li>
      </ul>
      <div class="card" v-show="tab === 'generator'">
        <div class="card-body">
          <div class="form-group">
            <label for="">{{ $t('music_style') }}</label>
            <select class="form-control" v-model="style">
              <option value="trap">Trap</option>
              <option value="lo-fi">Lo-Fi</option>
              <option value="boom-bap">Boom Bap</option>
              <option value="west-coast">West Coast</option>
              <option value="drill">Drill Style</option>
              <option value="old-style-hip-hop">{{ $t('old-style-hip-hop-style') }}</option>
              <option value="reggaeton">{{ $t('reggaeton-style') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">{{ $t('mood') }}</label>
            <select class="form-control" v-model="mood">
              <option value="dark-mood">{{ $t('dark-mood') }}</option>
              <option value="chill-mood">{{ $t('chill-mood') }}</option>
              <option value="aggressive-mood">{{ $t('aggressive-mood') }}</option>
              <option value="uplifting-mood">{{ $t('uplifting-mood') }}</option>
              <option value="melancholic-mood">{{ $t('melancholic-mood') }}</option>
              <option value="romantic-mood">{{ $t('romantic-mood') }}</option>
              <option value="motivated-mood">{{ $t('motivated-mood') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">{{ $t('speed') }}</label>
            <select class="form-control" v-model="speed">
              <option value="slow-tempo">{{ $t('slow-tempo') }}</option>
              <option value="medium-tempo">{{ $t('medium-tempo') }}</option>
              <option value="fast-tempo">{{ $t('fast-tempo') }}</option>
              <option value="very-fast-tempo">{{ $t('very-fast-tempo') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">{{ $t('featured_instrument') }}</label>
            <select class="form-control" v-model="featured_instrument">
              <option value="heavy-bass">{{ $t('heavy-bass') }}</option>
              <option value="synths">{{ $t('synths') }}</option>
              <option value="guitar-riffs">{{ $t('guitar-riffs') }}</option>
              <option value="piano-keys">{{ $t('piano-keys') }}</option>
              <option value="orchestral-elements">{{ $t('orchestral-elements') }}</option>
            </select>
          </div>
        </div>
        <div class="card-footer text-right">
          <button type="button" class="btn btn-primary" :disabled="loading || !available" @click="createBeat()">
            {{ $t('generate') }}
          </button>
        </div>
      </div>
      <div class="card" v-show="tab === 'beats'">
        <div class="card-body p-0 table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th width="100">
                </th>
                <th>{{ $t('title') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(beat, index) in beats" v-bind:key="`beat_${index}`">
                <td>
                  <img :src="beat.image_url || defaultImage" width="100%" alt="">
                </td>
                <td>
                  <span v-if="!beat.url">
                    <i class="fa fa-spinner fa-spin mr-1"></i> {{ $t('please_wait_ai_beat') }}
                  </span>
                  <span v-if="beat.url">
                    {{ beat.title }} (ver. {{ beat.version }})
                  </span>
                </td>
                <td class="text-right">
                  <a :href="beat.url" class="btn btn-sm btn-default" target="_blank" v-if="beat.url">
                    {{ $t('download') }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <a href="#" ref="downloadLink" style="display:none;"></a>
  </div>
</template>
<script>
import AI from '../services/ai'
import moment from 'moment'
import _ from 'underscore'

export default {
  name: 'AIBeats',
  data: function () {
    return {
      moment,
      defaultImage: '/static/img/img-placeholder.jpg',
      tab: 'generator',
      style: 'trap',
      mood: 'chill-mood',
      speed: 'slow-tempo',
      featured_instrument: 'heavy-bass',
      background: 'futuristic-cityscape',
      loading: false,
      blob: null,
      url: '',
      beats: [],
      available: 0
    }
  },
  methods: {
    checkBeat: function (beat, beatIndex) {
      AI.getAIBeat(beat._id).then(response => {
        let item = response.data

        if (!item.url) {
          setTimeout(() => {
            this.checkBeat(beat, beatIndex)
          }, 1000 * 10)
        } else {
          _.extend(this.beats[beatIndex], item)
          this.$forceUpdate()
        }
      }).catch(() => {
        setTimeout(() => {
          this.checkBeat(beat, beatIndex)
        }, 1000 * 10)
      })
    },
    getAIBeats: function () {
      AI.getAIBeats().then(response => {
        this.beats = response.data.items

        if (response.data.available > 0) {
          this.available = response.data.available / 2
        } else {
          this.available = 0
        }

        this.beats.forEach((beat, beatIndex) => {
          if (!beat.url) {
            setTimeout(() => {
              this.checkBeat(beat, beatIndex)
            }, 3000 * beatIndex)
          }
        })
      })
    },
    download: function () {
      fetch(this.url)
        .then(response => response.blob())
        .then(blob => {
          window.$(this.$refs.downloadLink).attr('href', window.URL.createObjectURL(blob))
          window.$(this.$refs.downloadLink).attr('download', `indiefy-beat-${this.style}-${this.color}-${this.background}-${new Date().getTime()}.mp3`)
          window.$(this.$refs.downloadLink)[0].click()
        })
    },
    createBeat: function () {
      if (!this.user.subscription || this.user.subscription.plan_name === 'indiefy_lite') {
        return this.$router.push('/upgrade?from=ai-beat')
      }

      this.url = ''
      this.loading = true

      AI.createBeat({ style: this.style, mood: this.mood, featured_instrument: this.featured_instrument, speed: this.speed }).then((response) => {
        this.url = response.data.url
        this.loading = false
        this.getAIBeats()
        this.tab = 'beats'
      }).catch(() => {
        alert('An error occurred, please contact support')
        this.loading = false
      })
    }
  },
  mounted: function () {
    window.$('html, body').animate({
      scrollTop: 0
    }, 500)
  },
  created: function () {
    this.user = this.$user
    this.getAIBeats()
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AIBeats.vue